import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilitiesPaginatedGlobalSearchResponse } from '@libs/generated-types/utilities';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private readonly apiUrl: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {
    // Use environment service to get the API URL
    this.apiUrl = this.environmentService.utilitiesServiceUrl + '/global-search';
  }

  getResults(query: any): Observable<UtilitiesPaginatedGlobalSearchResponse> {
    const params = { ...query };
    return this.http.get<UtilitiesPaginatedGlobalSearchResponse>(this.apiUrl, { params });
  }
}
